<section
  class="pc-dialog flex max-h-[92vh] flex-col overflow-hidden rounded-2xl border border-solid border-[var(--pc-border)] bg-[var(--pc-surface)] font-sans text-sm text-[var(--pc-text)] shadow-2xl"
  [attr.data-theme]="data.theme"
>
  <header
    class="flex shrink-0 items-center justify-between gap-4 border-0 border-b border-solid border-[var(--pc-border)] px-5 py-4"
  >
    <div class="flex items-center gap-3">
      <span
        class="flex h-10 w-10 items-center justify-center rounded-xl bg-sky-500/10 text-sky-500"
        aria-hidden="true"
        ><i class="fa-solid fa-print"></i
      ></span>
      <div>
        <h2 id="package-label-title" class="text-lg font-bold tracking-tight">
          Print Package Label
        </h2>
        <p class="pc-hint">4 × 6 inches · Same package ID on every reprint</p>
      </div>
    </div>
    <button
      type="button"
      class="pc-icon-button"
      aria-label="Close label preview"
      (click)="ref.close()"
    >
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  </header>

  <div class="min-h-0 flex-1 overflow-auto bg-[var(--pc-subtle)] px-4 py-5">
    <p *ngIf="loading" role="status" class="pc-hint mb-4">Preparing package label…</p>
    <div class="pc-error" *ngIf="error" role="alert">
      {{ error }} <button class="pc-button ml-2" type="button" (click)="load()">Retry</button>
    </div>
    <!-- Physical label follows the existing trip/work-order package label. -->
    <article *ngIf="label as l" #printArea class="pl-label">
      <div class="label-preview">
        <div class="label-header">
          <div class="label-heading">
            <div class="label-customer">{{ l.package.customer_name || 'Unknown' }}</div>
            <div class="label-mid">{{ l.package.package_name || l.package.package_id }}</div>
            <div class="label-meta" *ngIf="l.package.store_number">
              Store {{ l.package.store_number }}
            </div>
          </div>
          <img class="brand-logo" [src]="logo" [alt]="brand" />
        </div>

        <div class="label-note">
          <div class="detail-line" *ngIf="model"><strong>Model:</strong> {{ model }}</div>
          <div class="barcode-container" *ngIf="model">
            <svg
              #modelBarcode
              class="barcode-model"
              role="img"
              [attr.aria-label]="'Model barcode ' + model"
            ></svg>
          </div>
          <div class="detail-line" *ngIf="serial"><strong>Serial:</strong> {{ serial }}</div>
          <div class="barcode-container" *ngIf="serial">
            <svg
              #serialBarcode
              class="barcode-serial"
              role="img"
              [attr.aria-label]="'Serial barcode ' + serial"
            ></svg>
          </div>
          <div class="detail-line detail-line--desc" *ngIf="description">
            <strong>Desc:</strong> {{ description }}
          </div>
          <div class="detail-line" *ngIf="l.package.length || l.package.width || l.package.height">
            <strong>Dims:</strong> {{ l.package.length || 0 }} x {{ l.package.width || 0 }} x
            {{ l.package.height || 0 }}
          </div>
          <div class="detail-line" *ngIf="l.package.weight">
            <strong>Weight:</strong> {{ l.package.weight }}
          </div>
          <div
            class="detail-line"
            *ngIf="l.package.stackable !== null && l.package.stackable !== undefined"
          >
            <strong>Stackable:</strong> {{ l.package.stackable ? 'Yes' : 'No' }}
          </div>
          <ng-container *ngIf="l.package.note">
            <div class="note-separator"></div>
            <div class="detail-note">{{ l.package.note }}</div>
          </ng-container>
        </div>

        <div class="label-details">
          <span *ngIf="labelDate"
            ><strong>{{ l.package.intake_date ? 'Date:' : 'Created:' }}</strong>
            {{ labelDate }}</span
          >
          <span *ngIf="quantity !== null" class="label-qty"
            ><strong>Qty:</strong> {{ quantity }}</span
          >
        </div>
        <div class="label-footer">
          <div class="uuidline"><strong>UUID:</strong><br />{{ l.package.package_uuid }}</div>
          <div class="qr">
            <img *ngIf="qrImage" [src]="qrImage" alt="Package identification QR code" />
          </div>
        </div>
      </div>
    </article>
  </div>

  <footer
    class="flex shrink-0 flex-wrap items-end justify-between gap-3 border-0 border-t border-solid border-[var(--pc-border)] px-5 py-4"
  >
    <label class="pc-label"
      >Label branding
      <select class="pc-input" [(ngModel)]="brand" [disabled]="printing">
        <option value="FBI">The FBI Group</option>
        <option value="ULAAP">ULAAP</option>
      </select>
    </label>
    <button
      type="button"
      class="pc-button pc-primary"
      (click)="print()"
      [disabled]="loading || !codesReady || !!error || printing"
    >
      <i class="fa-solid fa-print" aria-hidden="true"></i>
      {{ printing ? 'Preparing…' : 'Print Label' }}
    </button>
    <p class="pc-hint w-full">
      Choose your label printer in the print dialog. Use 4 × 6 paper and 100% scale.
    </p>
  </footer>
</section>
